import { registerPlugin } from '@capacitor/core';

export const CaddieCheckout = registerPlugin('CaddieCheckout', {
  web: () => ({
    open: async ({ url }) => {
      window.location.href = url;
    },
    close: async () => {},
    addListener: async () => ({ remove: async () => {} }),
  }),
});
